import { useSdkWebsocketConnexion, WebSocketStatus } from "@kalyzee/kast-web-sdk";
import { useRef } from "react";
import { Outlet } from "react-router-dom";
import ConnexionView from "../../../../components/utils/ConnexionView";
import { SessionMode } from "../../../../contexts/appStore/hooks";
import { useAppStoreSelector } from "../../../../contexts/appStore/selectors";
import { useSdkContext } from "../../../../contexts/sdk/context";
import styles from "./private.module.css";

const PrivatePage = () => {
  const sdkCtx = useSdkContext();

  const mode = useAppStoreSelector(state => state.mode);
  const screen = useAppStoreSelector(state => state.screen);
  const { socketStatus, retry } = useSdkWebsocketConnexion(sdkCtx.client, mode === SessionMode.MASTER);
  const elementRef = useRef<HTMLDivElement>(null);

  const status = socketStatus === WebSocketStatus.Online ? "connected" : socketStatus === WebSocketStatus.Offline ? "disconnected" : "connecting";

  return (
    <div className={styles.mainContainer} ref={elementRef}>
      {screen !== undefined ? (
        <div style={{ position: "absolute", top: "10px", right: "10px", color: "black", fontSize: "26px", fontWeight: "bold" }}>{`${screen}`}</div>
      ) : null}
      { mode === SessionMode.MASTER && <ConnexionView
        status={status}
        retry={() => {
          retry();
        }}
      />}
      { mode !== SessionMode.MASTER || status === "connected" ? (
        <div className={styles.main}>
          <Outlet />
        </div>
      ) : null}
    </div>
  );
};

export default PrivatePage;
